<mat-expansion-panel (closed)="claimCurtainOpened = false" (opened)="claimCurtainOpened = true" class="curtains" #panel>
  <mat-expansion-panel-header [collapsedHeight]="'70px'" [expandedHeight]="'70px'">
    <mat-panel-title>
      <div>
        @if (job?.requestForQuoteTimeStamp) {
          <div class="received-date">
            {{ job.requestForQuoteTimeStamp | dateepoch: currentUserTimezone }}
            {{ job.requestForQuoteTimeStamp | time: currentUserTimezone }}
          </div>
        }
        <div class="claim-number">
          <h5><span class="subtitle-1">Claim</span> {{ job?.claimNumber }}</h5>
          @if (job?.authority) {
            <div class="authorised-box" appHighlightStatus="AUTHORISED">AUTHORISED</div>
          }
          @if ((job?.enableToSelfAuthorized || job?.preAuthority) && !job?.authority) {
            <div class="authorised-box pre-authorised-box" appHighlightStatus="AUTHORISED">PRE-AUTHORISED</div>
          }
        </div>
      </div>
    </mat-panel-title>
    <mat-panel-description>
      <div class="closed-panel-description">
        @if (job?.vehicleDescription) {
          <div class="closed-curtain-data">
            <div class="labels body-2">Vehicle</div>
            <div class="data-values subtitle-2 display-ellipsis">{{ job.vehicleDescription }}</div>
          </div>
        }
        <div class="inspection-block" [ngClass]="{ 'self-center': !job?.inspectionDate }">
          @if (job?.inspectionDate) {
            <div class="closed-curtain-data">
              <div class="labels body-2">Inspection</div>
              <div class="data-values subtitle-2">{{ job.inspectionDate | date: dateDisplayFormat }}</div>
            </div>
          }
          <div class="closed-curtain-data">
            @if (job?.onSiteInspection) {
              <span class="on-site body-2 ml-10">On site</span>
            }
          </div>
        </div>
        @if (job?.excess || job?.excessType) {
          <div class="total-excess">
            <div class="labels body-2">Total Excess</div>
            <div class="data-values subtitle-2">
              @if (job?.excess) {
                <span>$</span>
              }
              <span>{{
                job?.excessType ? job?.excessType : job?.excess ? (job?.excess | number: '1.2-2') : 'Not Specified'
              }}</span>
            </div>
          </div>
        }
      </div>
      <div class="flex gap-x-20">
        <div
          #trigger="matMenuTrigger"
          class="flex justify-center justify-self-end items-center bg-white rounded-[4px] border! border-solid! border-neut-var-80! h-46 max-w-190"
          (mouseenter)="trigger.openMenu()"
          (mouseleave)="trigger.closeMenu()"
          [matMenuTriggerFor]="inscoTooltip">
          @if (!job?.logoUrl) {
            <div class="px-10">{{ job?.insco }}</div>
          } @else {
            <img src="{{ job?.logoUrl }}" alt="Job logo" class="max-w-140 max-h-38 pl-7" />
          }
          <mat-icon class="mx-10">info_outline</mat-icon>
        </div>
        <div class="flex items-center justify-center w-40">
          <pdf-button
            [menuItems]="
              (job?.enableToSelfAuthorized || job?.preAuthority) && !job?.authority
                ? [
                    { label: 'Repairer Report', value: 'repairer' },
                    { label: 'Pre Authority Report', value: 'pre_authorized' }
                  ]
                : [{ label: 'Repairer Report', value: 'repairer' }]
            "
            (openPDF)="openPdfReport($event)" />
        </div>
      </div>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <mat-divider></mat-divider>
  <form [formGroup]="claimForm">
    <div class="flex items-center gap-10">
      <h4>Repairer Instructions</h4>
      @if (job?.product) {
        <status-chip hasExtraPadding [status]="job?.product" class="mt-10" />
      }
    </div>

    <div class="grid grid-cols-[auto_292px_250px] gap-x-20">
      <mat-form-field class="no-validation" color="accent">
        <mat-label>Repairer Instructions</mat-label>
        <textarea
          matInput
          formControlName="repairerInstructions"
          maxlength="65535"
          cdkTextareaAutosize="true"></textarea>
      </mat-form-field>
      <mat-form-field class="no-validation">
        <mat-label>Assessment Instructions</mat-label>
        <input formControlName="assessmentInstruction" matInput />
      </mat-form-field>
      <mat-form-field class="no-validation">
        <mat-label>Assessment Category</mat-label>
        <input formControlName="assessmentCategory" matInput />
      </mat-form-field>
    </div>

    <h4>Vehicle</h4>
    <div class="field-group">
      <mat-form-field
        [class.read-only]="job?.cancelled || userService.isRepairerSiteSuspended()"
        class="w-[470px]! min-w-[470px]! primary-icon">
        <mat-label>Vehicle Description</mat-label>
        <input
          class="display-ellipsis vehicle-description"
          [class.editable]="!job?.vehicleSelectedFromGlassGuide"
          [required]="vehicleFromGlassMandatory"
          [readonly]="job?.vehicleSelectedFromGlassGuide"
          formControlName="vehicleDescription"
          matInput />
        <div matSuffix class="flex">
          @if (job?.vehicleSelectedFromGlassGuide) {
            <button
              (click)="confirmClearVMD()"
              [disabled]="job?.cancelled || userService.isRepairerSiteSuspended()"
              matIconButton
              type="button">
              <mat-icon class="text-charcoal-50! size-18! text-18!">backspace</mat-icon>
            </button>
          }
          <button
            (click)="selectVehicle()"
            [disabled]="job?.cancelled || userService.isRepairerSiteSuspended()"
            matIconButton
            type="button">
            <mat-icon class="car">directions_car</mat-icon>
          </button>
        </div>

        @if (job?.vehicleSelectedFromGlassGuide) {
          <mat-hint>Vehicle selected from Glass Guide</mat-hint>
        }
        @if (job?.unlistedGlassVehicle) {
          <mat-hint>The vehicle is not listed in Glass Guide</mat-hint>
        }
        @if (vehicleDescription.hasError('required')) {
          <mat-error> Vehicle Description is <strong>required</strong> </mat-error>
        }
        @if (!vehicleDescription.hasError('required') && vehicleDescription.hasError('mustBeSetFromGlassGuide')) {
          <mat-error> Vehicle <strong>must be set</strong> using the vehicle selector </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="w-[122px]! min-w-[112px]!">
        <mat-label>REGO</mat-label>
        <input formControlName="rego" matInput oninput="value = value.toUpperCase()" />
      </mat-form-field>
      <mat-form-field class="w-[122px]! min-w-[112px]!">
        <mat-label>State</mat-label>
        <mat-select
          disableOptionCentering="true"
          [panelClass]="'rego-state-options'"
          (selectionChange)="saveJob.emit({ fieldValue: regoState.value, fieldName: 'regoState' })"
          [required]="regoStateMandatory"
          formControlName="regoState">
          @for (groupState of groupStates; track groupState) {
            <mat-optgroup class="rego-state-group" [class.empty-label]="" [label]="groupState.group">
              @for (state of groupState.options; track state) {
                <mat-option [value]="state.value" [class.empty-option]="state.label === ''">
                  {{ state.label }}
                </mat-option>
              }
            </mat-optgroup>
          }
        </mat-select>
        <mat-error> State is <strong>required</strong> </mat-error>
      </mat-form-field>
      <mat-form-field [class.read-only]="regoExpiryDatepicker.disabled" class="medium-field primary-icon">
        <mat-label>REGO Expiry</mat-label>
        <input
          (dateChange)="dateChange('regoExpiryDate')"
          (keypress)="dateInputHelper.restrictDateInput($event)"
          [matDatepicker]="regoExpiryDatepicker"
          formControlName="regoExpiryDate"
          matInput />
        <mat-datepicker-toggle [for]="regoExpiryDatepicker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #regoExpiryDatepicker></mat-datepicker>
        @if (regoExpiryDate.enabled) {
          <mat-hint>Date format DD/MM/YYYY</mat-hint>
        }
        @if (!regoExpiryDate.valid) {
          <mat-error> The date format is <strong>DD/MM/YYYY</strong> </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="w-[150px]!">
        <mat-label>Odometer</mat-label>
        <input [required]="odometerMandatory" formControlName="odometer" matInput formatInputNumber maxlength="9" />
        @if (odometer.value) {
          <span class="text-[13px] text-charcoal-60 ml-5" matTextSuffix>Km</span>
        }
        @if (odometer.hasError('pattern')) {
          <mat-error> Only numbers are accepted </mat-error>
        }
        @if (odometer.hasError('required')) {
          <mat-error> Odometer is <strong>required</strong> </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="medium-field">
        <mat-label>VIN</mat-label>
        <input [required]="vinMandatory" formControlName="vin" matInput oninput="value = value.toUpperCase()" />
        <mat-error> VIN is <strong>required</strong> </mat-error>
      </mat-form-field>
      <mat-form-field class="medium-field">
        <mat-label>Body Colour</mat-label>
        <input formControlName="bodyColour" matInput />
      </mat-form-field>
      <mat-form-field class="medium-field">
        <mat-label>Condition</mat-label>
        <input formControlName="condition" matInput />
      </mat-form-field>
      <mat-form-field class="medium-field">
        <mat-label>Vehicle Value</mat-label>
        <input formControlName="vehicleValue" matInput />
        @if (vehicleValue.value) {
          <div class="text-charcoal-60 mr-5 subtitle-2" matTextPrefix>$</div>
        }
      </mat-form-field>
      <mat-form-field
        [class.read-only]="complianceDatepicker.disabled"
        appMonthYearDateFormat
        class="medium-field primary-icon">
        <mat-label>Compliance Date</mat-label>
        <input
          (dateChange)="dateChange('complianceDate')"
          (keypress)="dateInputHelper.restrictDateInput($event)"
          [matDatepicker]="complianceDatepicker"
          formControlName="complianceDate"
          matInput />
        <mat-datepicker-toggle [for]="complianceDatepicker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker
          #complianceDatepicker
          (closed)="complianceDate.dirty && dateChange('complianceDate')"
          (monthSelected)="chosenMonthHandler($event, complianceDatepicker)"
          (yearSelected)="chosenYearHandler($event)"
          startView="multi-year">
        </mat-datepicker>
        @if (complianceDate.enabled) {
          <mat-hint>Date format MM/YYYY</mat-hint>
        }
        @if (complianceDate.invalid) {
          <mat-error> The date format is <strong>MM/YYYY</strong> </mat-error>
        }
      </mat-form-field>
    </div>
    @if (job?.accessories?.length) {
      <div class="accessories grid grid-cols-2 gap-20 mt-10">
        @for (accessory of accessories.controls; track accessory; let i = $index) {
          <div formArrayName="accessories">
            <div class="flex gap-x-20" [formGroupName]="i">
              <mat-form-field class="no-validation">
                <mat-label>Vehicle Accessory Description</mat-label>
                <input formControlName="description" matInput />
              </mat-form-field>
              <mat-form-field class="medium-field no-validation">
                <mat-label>Value</mat-label>
                <input formControlName="value" matInput />
                <div class="text-charcoal-60 mr-5 subtitle-2" matTextPrefix>$</div>
              </mat-form-field>
            </div>
          </div>
        }
      </div>
    }

    <h4>Incident</h4>
    <div class="flex mb-20 gap-x-20">
      <mat-form-field class="no-validation">
        <mat-label>Accident Description</mat-label>
        <textarea
          matInput
          formControlName="accidentDescription"
          maxlength="65535"
          cdkTextareaAutosize="true"></textarea>
      </mat-form-field>
      <mat-form-field class="medium-field no-validation">
        <mat-label>Incident Date</mat-label>
        <input formControlName="incidentDate" matInput />
      </mat-form-field>
    </div>
    <mat-form-field class="medium-field max-w-[50%]! w-full! min-w-[450px]! no-validation">
      <mat-label>Accident Location</mat-label>
      <input formControlName="accidentLocation" matInput />
    </mat-form-field>

    <div class="flex items-center">
      <h4 class="mr-10">Inspection</h4>
      @if (job?.enableBooking) {
        <button
          matButton="elevated"
          class="charcoal-button"
          type="button"
          [matTooltipDisabled]="!showBooking"
          [matTooltip]="'You may only send one inspection booking at a time'"
          [matTooltipPosition]="'right'"
          (click)="inspectionBooking.emit({ action: 'addBooking' })"
          [disabled]="showBooking || userService.isRepairerSiteSuspended()">
          <mat-icon>create</mat-icon>
          BOOKING
        </button>
      }
    </div>
    <div class="field-group">
      @if (job?.onSiteInspection) {
        <div class="pt-10 mr-20">
          <span class="on-site body-2">On site</span>
        </div>
      }
      <mat-form-field class="medium-field no-validation">
        <mat-label>Inspection Date</mat-label>
        <input formControlName="inspectionDate" matInput />
      </mat-form-field>
      <mat-form-field class="medium-field no-validation">
        <mat-label>Inspection Type</mat-label>
        <input formControlName="inspectionType" matInput />
      </mat-form-field>
    </div>
  </form>
</mat-expansion-panel>
<mat-menu #inscoTooltip [hasBackdrop]="false" [xPosition]="'before'">
  <section class="insco-tooltip">
    <header class="subtitle-1">{{ job?.insco }}</header>
    <div class="contact subtitle-2">
      <mat-icon>pin_drop</mat-icon>
      <address>
        {{ job?.insurerAddress }}
        {{ job?.insurerSuburb }}
        {{ job?.insurerCountry === 'Australia' ? job?.insurerState : job?.insurerCity }}
        {{ job?.insurerCountry }}
      </address>
    </div>
  </section>
</mat-menu>
